import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { useState } from "react";

export default function BarChartComp({ services }) {
  // const [selectedService, setSelectedService] = useState(null);

  return (
    <div className="h-auto w-full space-y-4">
      <div className="">
        <ResponsiveContainer height={300}>
          <BarChart
          activeBar={false}
            data={services}
            layout="vertical"
            margin={{ top: 10, right: 20, left: 40, bottom: 0 }}
          >
            <CartesianGrid
              stroke="#e5f3fa"   
              strokeDasharray="3 3"
              strokeWidth={1.2}       
            />
            <XAxis
              type="number"
              tick={{ fill: "#1A202C", fontWeight: 500, fontSize: 12 }}
              axisLine={{ stroke: "#A0AEC0", strokeWidth: 1.5 }} 
              tickLine={{ stroke: "#A0AEC0", strokeWidth: 1 }}
            />
            <YAxis
              dataKey="name"
              type="category"
              tick={{ fill: "#1A202C", fontWeight: 500, fontSize: 12 }}
              axisLine={{ stroke: "#A0AEC0", strokeWidth: 1.5 }} // thicker axis line
              tickLine={{ stroke: "#A0AEC0", strokeWidth: 1 }}
            />
            <Tooltip
            cursor={false}
              // contentStyle={{
              //   backgroundColor: "#fff",
              //   border: "1px solid #e2e8f0",
              //   borderRadius: "6px",
              //   fontSize: "12px",
              // }}
            />
            <Bar
              dataKey="value"
              fill="#3383B2"
              radius={[0, 6, 6, 0]}
              barSize={20}
              isAnimationActive={false}
              // onClick={(data) => setSelectedService(data)}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* {selectedService && (
        <div className="bg-gray-100 p-4 rounded-lg shadow-inner">
          <div className="flex justify-between mb-2">
            <h3 className="font-semibold text-lg">Details: {selectedService.name}</h3>
            <button
              className="text-sm text-red-600"
              onClick={() => setSelectedService(null)}
            >
              Close
            </button>
          </div>
          <ul className="text-sm list-disc pl-5 space-y-1">
            {selectedService.details.map((item) => (
              <li key={item.id}>
                Customer: {item.customer}, Amount: {item.amount}, Date: {item.date}
              </li>
            ))}
          </ul>
        </div>
      )} */}
    </div>
  );
}
